$(document).ready(function() {

	//--------------------------------------------------------------------------
	// CREDIT PACK → BUY NOW BUTTON
	//--------------------------------------------------------------------------
	$('.storage__credits-buy').off('click').on('click', function (e) {
		e.preventDefault();

		let priceId  = $(this).data('price-id');
		let credits  = $(this).data('credits');
		let amount   = $(this).data('amount');
		let isGuest  = $(this).data('guest') == 1;

		$('#credits_amount').text(credits);
		$('#credits_price').text(amount);
		// Reset modal steps
		$('.step').hide();
		$('#promo-message').html('');
		$('#promo-code').val('');

		$('body').addClass('menu-open');
		$('.modal__credits-payment').addClass('open');

		if (!isGuest) {
			//--------------------------------------------------------------
			// LOGGED IN → create PI → go straight to payment
			//--------------------------------------------------------------
			createPaymentIntent(priceId, function () {
				$('#step-payment').show();
				setTimeout(initialiseStripeForm, 50);
			});

		} else {
			//--------------------------------------------------------------
			// GUEST → show register step first
			//--------------------------------------------------------------
			$('#step-register').show();
			$('#step-login').hide();
			$('#step-payment').hide();
			$('#step-password').hide();
			$('#step-complete').hide();

			// store globally
			window.payg_price_id = priceId;
		}
	});


	//--------------------------------------------------------------------------
	// STEP 1 → REGISTER (GUEST)
	//--------------------------------------------------------------------------
	$(document).on('submit', '#payg-register-form', function (e) {
		e.preventDefault();

		let form = $(this);
		let data = form.serialize()
			+ '&price_id=' + window.payg_price_id
			+ '&location_id=' + $('input[name=location_id]').val();

		console.log('Submitting register step with data:', data);

		showLoader();
		$.post('/buy-credits/start-register/', data, function (res) {
			hideLoader();
			console.log('start-register response:', res);

			if (res.status === 'success') {
				window.payg_register_email = $('input[name="client_email"]').val();

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'registrationSuccess'
				});

				console.log('Creating PI for price_id:', window.payg_price_id);

				createPaymentIntent(window.payg_price_id, function () {
					console.log('PI created — switching to payment step');

					$('.step').hide();
					$('#step-payment').show();

					// Now initialise Stripe form
					setTimeout(initialiseStripeForm, 50);
				});

			} else {
				console.log('Registration error:', res.message);
				$('#payg-register-error').html(res.message);
			}
		}, 'json');
	});


	//--------------------------------------------------------------------------
	// STEP 1b → LOGIN INSIDE MODAL
	//--------------------------------------------------------------------------
	$(document).on('submit', '#payg-login-form', function (e) {
		e.preventDefault();

		showLoader();
		$.post('/buy-credits/login/', $(this).serialize(), function (res) {
			if (res.status === 'success') {
				hideLoader();

				// 🔥 Important — user is now logged in
				window.is_logged_in = true;

				createPaymentIntent(window.payg_price_id, function () {
					$('.step').hide();
					$('#step-payment').show();

					// Now initialise Stripe form
					setTimeout(initialiseStripeForm, 50);
				});

			} else if (res.status === 'reload') {
				hideLoader();
				window.location.href = window.location.pathname + window.location.search;

			} else {
				hideLoader();
				$('#payg-login-error').html(res.message);
			}
		}, 'json');
	});


	//--------------------------------------------------------------------------
	// STRIPE PAYMENT STEP (Step 2)
	//--------------------------------------------------------------------------
	let stripe = null;
	let cardNumber = null;
	let cardExpiry = null;
	let cardCvc = null;

	// Mount Elements when step-payment is shown
	function initialiseStripeForm() {

		// DESTROY existing Elements cleanly
		if (cardNumber) cardNumber.destroy();
		if (cardExpiry) cardExpiry.destroy();
		if (cardCvc) cardCvc.destroy();

		console.log('init stripe...');

		var form = document.getElementById('payment-form');
		if (!form) return;

		var publishableKey = form.dataset.stripePublishableKey;
		var clientSecret   = form.dataset.clientSecret;

		if (!publishableKey || !clientSecret) return;

		/*
		 * -------------------------------------------------------
		 * DESTROY existing Stripe Elements (if any)
		 * -------------------------------------------------------
		 */
		if (form._stripeElements) {
			try {
				form._stripeElements.destroy();
			} catch (e) {}
			form._stripeElements = null;
			form._paymentElement = null;
		}

		/*
		 * -------------------------------------------------------
		 * CREATE Stripe instance (cached on form)
		 * -------------------------------------------------------
		 */
		if (!form._stripe) {
			form._stripe = Stripe(publishableKey);
		}

		/*
		 * -------------------------------------------------------
		 * CREATE Elements
		 * -------------------------------------------------------
		 */
		var elements = form._stripe.elements({
			clientSecret: clientSecret,
			appearance: {
				theme: 'night'
			}
		});

		form._stripeElements = elements;

		var paymentElement = elements.create('payment', {
			wallets: {
				applePay: 'auto',
				googlePay: 'auto',
				link: 'never'
			},
			fields: {
				billing_details: {
					address: {
						country: 'GB'
					}
				}
			}
		});

		form._paymentElement = paymentElement;

		paymentElement.mount('#card-number-element');

		/*
		 * -------------------------------------------------------
		 * Update button label (Card / Klarna)
		 * -------------------------------------------------------
		 */
		paymentElement.on('change', function (event) {
			var label = 'Complete Payment';

			if (event.value && event.value.type === 'klarna') {
				label = 'Pay with Klarna';
			}

			$('#submit').text(label);
		});

		/*
		 * -------------------------------------------------------
		 * Submit handler
		 * -------------------------------------------------------
		 */
		$('#submit').off('click').on('click', function (e) {
			e.preventDefault();

			const $btn = $(this);
			const originalText = $btn.text();
			// Lock button
			$btn
				.prop('disabled', true)
				.addClass('is-loading')
				.text('Please wait…');

			form._stripe.confirmPayment({
				elements: form._stripeElements,
				confirmParams: {
					return_url: window.location.href
				}
			}).then(function (result) {

				// Stripe only returns here for immediate errors
				if (result.error) {
					// Unlock button
					$btn
						.prop('disabled', false)
						.removeClass('is-loading')
						.text(originalText);

					alert(result.error.message || 'Payment failed, please try again.');
				}

				// If no error → redirect happens automatically
			});
		});
	}


	//--------------------------------------------------------------------------
	// CREATE PAYMENT INTENT (shared by register + login + logged in)
	//--------------------------------------------------------------------------
	function createPaymentIntent(priceId, callback) {
		let loc = $('input[name=location_id]').val() || '';

		showLoader();
		$.post('/buy-credits/create-intent/', {
			price_id: priceId,
			location_id: loc
		}, function (res) {
			hideLoader();
			console.log('create-intent response:', res);

			if (res.status === 'success') {

				const $form = $('#payment-form');


				window.payg_credit_id = res.credit_id;
				window.payg_pi_id = res.pi_id || null;
				window.payg_amount = parseFloat(res.amount_display) || 0;

				$form
					.attr('data-credit-id', res.credit_id)
					.attr('data-pi-id', res.pi_id || '')
					.attr('data-client-secret', res.client_secret)
					.attr('data-stripe-publishable-key', res.publishable_key);

				if (res.amount_display) {
					$('#credits_price').text(res.amount_display);
				}

				if (typeof callback === 'function') {
					callback();
				}
			} else {
				console.error('create-intent error:', res);
				alert(res.message || 'Unable to start payment.');
			}
		}, 'json');
	}

	//--------------------------------------------------------------------------
	// SWITCH BETWEEN LOGIN / REGISTER
	//--------------------------------------------------------------------------
	$('#payg-show-login').on('click', function (e) {
		e.preventDefault();
		$('.step').hide();
		$('#step-login').show();
	});
	$('#payg-show-register').on('click', function (e) {
		e.preventDefault();
		$('.step').hide();
		$('#step-register').show();
	});



	//--------------------------------------------------------------------------
	// STRIPE PAYMENT SUCCESS → MOVE TO PASSWORD STEP
	// (put this inside your stripe.confirmCardPayment success handler)
	//--------------------------------------------------------------------------
	// After payment succeeds:
	function waitForCreditPayment(callback, attempt = 0) {
		$.get(`/buy-credits/markpaid/${window.payg_credit_id}/`, function(res) {
			if (res.status === 'success') { callback(res); return; }
			if (res.status === 'pending' && attempt < 30) {
				setTimeout(() => waitForCreditPayment(callback, attempt + 1), 2000);
				return;
			}
			hideLoader();
			$('#error-message').text('Your payment is being confirmed. Please check your credits shortly.');
		}, 'json').fail(function() {
			hideLoader();
			$('#error-message').text('Unable to check your payment. Please check your credits shortly.');
		});
	}

	function payg_afterPaymentSuccess() {

		// Mark credit paid
		showLoader();
		waitForCreditPayment(function(res) {
			hideLoader();
			console.log('markpaid response:', res);

			console.groupCollapsed('[GTM] stripePaymentSuccess');
			console.log('time:', new Date().toISOString());
			console.log('credit_id:', window.payg_credit_id);
			console.log('amount:', window.payg_amount);
			console.log('currency:', 'GBP');
			console.log('is_logged_in:', window.is_logged_in);
			console.log('location_id:', $('input[name=location_id]').val() || null);

			// Google Tracking
			const dlEvent = {
				event: 'stripePaymentSuccess',
				transactionId: window.payg_credit_id,
				value: window.payg_amount || 0,
				currency: 'GBP'
			};

			console.log('pushing:', dlEvent);
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(dlEvent);

			// Meta / Facebook Tracking
			if (typeof fbq === 'function') {
				fbq('track', 'Purchase', {
					value: window.payg_amount || 0,
					currency: 'GBP'
				});
			}

			console.log('dataLayer length now:', window.dataLayer.length);
			console.log('last entry:', window.dataLayer[window.dataLayer.length - 1]);




			$('.step').hide();

			// If user is LOGGED IN → skip password, go to complete
			if (window.is_logged_in) {
				$('#step-complete').show();
			}

			// Guest user → show password step
			else {
				$('#step-password').show();
			}

		}, 'json');
	}

	//--------------------------------------------------------------------------
	// STEP 3 → PASSWORD CREATION
	//--------------------------------------------------------------------------
	$(document).on('submit', '#payment-form-password', function (e) {
		e.preventDefault();

		showLoader();
		$.post('/buy-credits/register-password/', $(this).serialize(), function (res) {
			hideLoader();
			if (res.status === 'success') {

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'registrationSuccess'
				});

				$('.step').hide();
				$('#step-complete').show();

			} else {
				alert(res.message);
			}
		}, 'json');
	});


	//--------------------------------------------------------------------------
	// CLOSE MODAL
	//--------------------------------------------------------------------------
	$('.storage__credits-close').on('click', function () {

		const $form = $('#payment-form');

		// Extract PI from data-client-secret="pi_XXX_secret_YYY"
		const clientSecret = $form.data('client-secret');
		let paymentIntentId = null;

		if (clientSecret) {
			paymentIntentId = clientSecret.split('_secret')[0];
		}



		// If we have a PI, cancel it server side AND clear promo + credit state
		hideLoader();
		if (paymentIntentId && window.payg_credit_id) {
			showLoader();
			$.post('/buy-credits/cancel-payment-intent/', {
				credit_id: window.payg_credit_id
			}, function(res) {
				console.log('PI cancelled:', res);
			}, 'json');
		}

		// Reset global vars
		window.payg_credit_id = null;
		window.payg_pi_id = null;
		window.payg_register_email = null;

		// Reset form attributes
		$form.removeAttr('data-client-secret');
		$form.removeAttr('data-credit-id');
		$form.removeAttr('data-pi-id');
		$form.removeAttr('data-stripe-publishable-key');

		// Reset promo UI
		$('#promo-box').show();
		$('#applied-promo-box').hide();
		$('#promo-code').val('');
		// Unmount Stripe Elements (in case they mounted)
		stripe = null;

		// Reset modal steps
		$('.step').hide();
		$('#step-start').show();

		// Close modal UI
		$('body').removeClass('menu-open');
		$('.modal__credits-payment').removeClass('open');
		$('.global-loader').removeClass('show');
	});

	$(document).on('click', '#step-complete', function () {
		window.location.href = '/schedule/';
	});

	$('#apply-promo').off('click').on('click', function() {
		var code = $('#promo-code').val().trim();
		var creditId = $('#payment-form').data('credit-id');

		if (!code) return $('#promo-message').text('Please enter a code.');

		showLoader();
		$.post('/buy-credits/apply-promo/', {
			promo_code: code,
			credit_id: creditId
		}).done(function(resp) {
			hideLoader();
			console.log(resp);

			if (resp.status === 200) {
				if (resp.free === true) {

					$('#promo-code').closest('.form-group').hide();
					$('#card-number-element').hide();
					$('#submit').hide();

					$('.stripe__form').hide();

					$('#step-payment').append(`
						<div class="free-payment">
							<p><strong>There's nothing to pay.</strong></p>
							<button class="button button--black lg wide" id="complete-free-payment">
								Complete
							</button>
						</div>
					`);

					$('#credits_price').text('0.00');
					return;
				}

				$('#promo-message').hide();
				$('#promo-code').closest('.form-group').hide(); // hide the form

				// Show applied code summary
				const discountLabel =
					resp.discount_type === 'percent'
						? `${resp.discount_amount}%`
						: `${resp.discount_amount.toFixed(2)}`;

				const appliedHtml = `
					<div id="promo-applied" class="mt-2">
						<strong>${resp.promo_code}</strong> – ${discountLabel} off
						<a href="#" id="remove-promo" class="ml-2" style="color:red;">
							<i class="fa fa-trash"></i> Remove
						</a>
					</div>`;

				$('#promo-code').closest('.form-group').after(appliedHtml);

				// Update modal price
				$('#credits_price').text(resp.new_price.toFixed(2));


				// Update form
				const $form = $('#payment-form');
				$form.attr('data-client-secret', resp.client_secret)

				if (resp.client_secret) {
					initialiseStripeForm();
				}
			} else {
				$('#promo-message').text(resp.message).css('color', 'red');
			}
		}).fail(function() {
			$('#promo-message').text('Error validating code').css('color', 'red');
		});
	});

	$(document).on('click', '#complete-free-payment', function() {

		showLoader();

		waitForCreditPayment(function(res) {
			hideLoader();

			console.groupCollapsed('[GTM] stripePaymentSuccess');
			console.log('time:', new Date().toISOString());
			console.log('credit_id:', window.payg_credit_id);
			console.log('amount:', window.payg_amount);
			console.log('currency:', 'GBP');
			console.log('is_logged_in:', window.is_logged_in);
			console.log('location_id:', $('input[name=location_id]').val() || null);

			const dlEvent = {
				event: 'stripePaymentSuccess',
				transactionId: window.payg_credit_id,
				value: window.payg_amount || 0,
				currency: 'GBP'
			};

			console.log('pushing:', dlEvent);
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(dlEvent);
			console.log('dataLayer length now:', window.dataLayer.length);
			console.log('last entry:', window.dataLayer[window.dataLayer.length - 1]);
			console.groupEnd();

			$('.step').hide();

			if (window.is_logged_in) {
				$('#step-complete').show();
			} else {
				$('#step-password').show();
			}

		}, 'json');
	});

	$(document).on('click', '#remove-promo', function(e) {
		e.preventDefault();
		var creditId = $('#payment-form').data('credit-id');

		showLoader();
		$.post('/buy-credits/remove-promo/', { credit_id: creditId })
			.done(function(resp) {
				hideLoader();
				if (resp.status === 200) {
					console.log(resp);
					$('#promo-applied').remove();
					$('#promo-code').closest('.form-group').show();
					$('#promo-code, #apply-promo').prop('disabled', false).val('');
					$('#promo-message').text('Promo removed.').css('color', 'red').show();

					// revert modal price
					const price = parseFloat(resp.new_price || 0).toFixed(2);
					$('#credits_price').text(price);
					$('.modal__credits-payment h3 span').html(
						`You are buying <span id="credits_amount"></span> Credits for £${price}`
					);
				} else {
					$('#promo-message').text(resp.message).css('color', 'red').show();
				}
			})
			.fail(function() {
				$('#promo-message').text('Error removing code').css('color', 'red').show();
			});
	});

	let subscriptionStripe = null;
	let subscriptionElements = null;
	let subscriptionPaymentElement = null;
	let subscriptionMembershipId = null;
	let subscriptionId = null;
	let subscriptionCompleted = false;

	function getSubscribeForm() {
		return document.getElementById('subscribe-form') || document.getElementById('subscribe-form_upgrade');
	}

	function showSubscriptionMessage(message) {
		$('#subscription-checkout-message').text(message).show();
	}

	function showSubscriptionContractMessage(message) {
		$('#subscription-contract-message').text(message).show();
	}

	function resetSubscriptionMessage() {
		$('#subscription-checkout-message').hide().text('');
		$('#subscription-contract-message').hide().text('');
	}

	function validateSubscriptionDiscount($form) {
		var code = $.trim($form.find('[name="discount_code"]').val());
		var action = $form.attr('action');
		var $field = $form.find('.subscription-discount-field');
		var $button = $field.find('.apply-subscription-discount');
		$button.prop('disabled', true).text('Checking…');
		return $.ajax({
			url: action.replace('/subscribe/', '/check-subscription-discount/'),
			type: 'POST', dataType: 'json', data: { discount_code: code }
		}).then(function(resp) {
			if ($form.attr('action') !== action || $.trim($form.find('[name="discount_code"]').val()) !== code) return false;
			$field.find('.subscription-discount-message').text(resp.message || 'Unable to check this code.');
			var valid = resp.status === 'success';
			$form.data('validated-discount', valid ? code : null);
			$field.find('.subscription-discount-eligibility').toggle(valid && !!resp.eligibility_required);
			$field.find('.subscription-discount-terms').text(valid ? resp.eligibility_terms : '');
			$field.find('[name="discount_eligibility"]').prop('required', valid && !!resp.eligibility_required);
			return valid;
		}, function() {
			$field.find('.subscription-discount-message').text('Unable to check this code. Please try again.');
			return false;
		}).always(function() { $button.prop('disabled', false).text('Apply'); });
	}

	$(document).on('click', '.apply-subscription-discount', function() {
		validateSubscriptionDiscount($(this).closest('form'));
	});
	$(document).on('input', '.sub-form [name="discount_code"]', function() {
		var $form = $(this).closest('form');
		$form.removeData('validated-discount');
		$form.find('.subscription-discount-message, .subscription-discount-terms').text('');
		$form.find('.subscription-discount-eligibility').hide();
		$form.find('[name="discount_eligibility"]').prop('checked', false).prop('required', false);
	});

	$(document).on('click', '.apply-subscription-trainer-referral', function() {
		var $button = $(this);
		var $field = $button.closest('.trainer-referral-field');
		var $input = $field.find('input[name="trainer_referral_code"]');
		var $message = $input.closest('.trainer-referral-field').find('.trainer-referral-message');
		var code = $.trim($input.val()).toUpperCase();

		$input.val(code);
		$message.text('').removeAttr('style');

		if (!code) {
			return;
		}

		$button.prop('disabled', true).text('Applying...');

		$.post('/buy-credits/check-trainer-referral/', {
			trainer_referral_code: code
		}, function(resp) {
			if ($.trim($input.val()).toUpperCase() !== code) {
				$button.prop('disabled', false).text('Apply');
				return;
			}

			if (resp.status === 'success') {
				$message
					.text('Thank you, ' + (resp.trainer_name || 'your trainer') + ' is your referrer.')
					.css('color', '#a4e7b5');
				$button.text('Applied');
				return;
			}

			$message
				.text(resp.message || 'The referral code entered is not valid.')
				.css('color', '#fca7a7');
			$button.prop('disabled', false).text('Apply');
		}, 'json').fail(function() {
			$message.text('').removeAttr('style');
			$button.prop('disabled', false).text('Apply');
		});
	});

	$(document).on('input', '.trainer-referral-field input[name="trainer_referral_code"]', function() {
		var $field = $(this).closest('.trainer-referral-field');
		$field.find('.trainer-referral-message').text('').removeAttr('style');
		$field.find('.apply-subscription-trainer-referral').prop('disabled', false).text('Apply');
	});

	function resetSubscriptionModalState() {
		if (subscriptionPaymentElement) {
			try {
				subscriptionPaymentElement.destroy();
			} catch (e) {}
		}

		subscriptionPaymentElement = null;
		subscriptionElements = null;
		subscriptionId = null;
		subscriptionMembershipId = null;
		subscriptionCompleted = false;
		$('.modal__subscribe [name="discount_code"]').val('').trigger('input');

		resetSubscriptionMessage();
		$('#subscription-payment-element').empty();
		$('#subscription-payment-form')
			.removeAttr('data-client-secret')
			.removeAttr('data-stripe-publishable-key')
			.removeAttr('data-subscription-id')
			.removeAttr('data-membership-id');
		$('#subscription-pay').prop('disabled', false).removeClass('is-loading').text('Start Subscription');
		$('#subscription-pay-amount').text('');
		$('#subscription-checkout-amount').text('');
		$('.modal__subscribe #subscription-contract-step, .modal__subscribe .subscription-signoff, .modal__subscribe .sub-form').show();
		$('.modal__subscribe #subscription-checkout-step').hide();
	}

	function cancelPendingSubscription() {
		if (!subscriptionMembershipId || subscriptionCompleted) {
			return;
		}

		$.post('/buy-credits/cancel-pending-subscription/', {
			membership_id: subscriptionMembershipId
		});
	}

	function closeSubscriptionModal() {
		cancelPendingSubscription();
		resetSubscriptionModalState();
		$('body').removeClass('menu-open');
		$('.modal__subscribe').removeClass('open');
	}

	function completeSubscriptionPayment() {
		if (!subscriptionId || !subscriptionMembershipId) {
			showSubscriptionMessage('We could not confirm this subscription yet. Please refresh and check your account.');
			return;
		}

		showLoader();

		$.post('/buy-credits/subscription-complete/', {
			subscription_id: subscriptionId,
			membership_id: subscriptionMembershipId
		}, function(resp) {
			hideLoader();

			if (resp.status === 'success' && resp.redirect_url) {
				window.location.href = resp.redirect_url;
				return;
			}

			$('#subscription-pay').prop('disabled', false).removeClass('is-loading').text('Start Subscription');
			showSubscriptionMessage(resp.message || 'Payment completed, but we could not finish setting up the subscription.');
		}, 'json').fail(function() {
			hideLoader();
			$('#subscription-pay').prop('disabled', false).removeClass('is-loading').text('Start Subscription');
			showSubscriptionMessage('Payment completed, but we could not finish setting up the subscription.');
		});
	}

	function initialiseSubscriptionPaymentForm() {
		var form = document.getElementById('subscription-payment-form');

		if (!form || !window.Stripe) {
			return;
		}

		var publishableKey = form.dataset.stripePublishableKey;
		var clientSecret = form.dataset.clientSecret;

		if (!publishableKey || !clientSecret) {
			showSubscriptionContractMessage('We could not start the secure payment form. Please try again.');
			return;
		}

		if (!subscriptionStripe || subscriptionStripe._pk !== publishableKey) {
			subscriptionStripe = Stripe(publishableKey);
			subscriptionStripe._pk = publishableKey;
		}

		if (subscriptionPaymentElement) {
			try {
				subscriptionPaymentElement.destroy();
			} catch (e) {}
		}

		subscriptionElements = subscriptionStripe.elements({
			clientSecret: clientSecret,
			appearance: {
				theme: 'night'
			}
		});

		subscriptionPaymentElement = subscriptionElements.create('payment', {
			wallets: {
				applePay: 'auto',
				googlePay: 'auto',
				link: 'never'
			},
			fields: {
				billing_details: {
					address: {
						country: 'GB'
					}
				}
			}
		});

		subscriptionPaymentElement.mount('#subscription-payment-element');
	}

	function launchSubscriptionPayment(resp) {
		if (!window.Stripe) {
			showSubscriptionContractMessage('Stripe is not available right now. Please refresh and try again.');
			return;
		}

		if (!resp.publishable_key || !resp.client_secret || !resp.subscription_id || !resp.membership_id) {
			showSubscriptionContractMessage('We could not start the secure payment form. Please try again.');
			return;
		}

		subscriptionId = resp.subscription_id;
		subscriptionMembershipId = resp.membership_id;
		subscriptionCompleted = false;

		$('#subscription-payment-form')
			.attr('data-client-secret', resp.client_secret)
			.attr('data-stripe-publishable-key', resp.publishable_key)
			.attr('data-subscription-id', resp.subscription_id)
			.attr('data-membership-id', resp.membership_id)
			.attr('data-intent-type', resp.intent_type || 'payment');
		var formattedAmount = resp.amount ? '£' + resp.amount : '';

		if (resp.intent_type === 'setup') $('#subscription-pay').text('Save card & start subscription');
		$('#subscription-pay-amount').text(formattedAmount);
		$('#subscription-checkout-amount').text(formattedAmount);
		$('.modal__subscribe #subscription-contract-step, .modal__subscribe .subscription-signoff, .modal__subscribe .sub-form').hide();
		$('.modal__subscribe #subscription-checkout-step').show();
		resetSubscriptionMessage();
		$('#subscription-payment-element').empty();

		try {
			initialiseSubscriptionPaymentForm();
		} catch (error) {
			console.error('Subscription payment form failed to initialise:', error);
			showSubscriptionContractMessage('We could not load the secure payment form. Please try again.');
			$('.modal__subscribe #subscription-contract-step, .modal__subscribe .subscription-signoff, .modal__subscribe .sub-form').show();
			$('.modal__subscribe #subscription-checkout-step').hide();
		}
	}

	$(document).on('submit', '.modal__subscribe .sub-form', function(e) {
		e.preventDefault();

		var $form = $(this);
		var signature = $.trim($form.find('input[name="signature"]').val());
		var action = $form.attr('action');
		var $submit = $form.find('[type="submit"]');
		var originalText = $submit.text();

		if (!signature) {
			alert('Please type your full name to sign the subscription terms.');
			return;
		}

		var discountCode = $.trim($form.find('[name="discount_code"]').val());
		if (discountCode && $form.data('validated-discount') !== discountCode) {
			$submit.prop('disabled', true);
			validateSubscriptionDiscount($form).then(function(valid) {
				$submit.prop('disabled', false);
				if (valid) $form.trigger('submit');
			});
			return;
		}
		var $eligibility = $form.find('[name="discount_eligibility"]');
		if ($eligibility.prop('required') && !$eligibility.prop('checked')) {
			showSubscriptionContractMessage('Please confirm that you qualify for the offer before continuing.');
			return;
		}

		resetSubscriptionMessage();
		showLoader();

		$submit.prop('disabled', true).text('Please wait…');

		$.ajax({
			url: action,
			type: 'POST',
			dataType: 'json',
			data: $form.serialize() + '&subscription_modal=1',
			success: function(resp) {
				hideLoader();
				$submit.prop('disabled', false).text(originalText);

				if (resp.status !== 'success') {
					var errorMessage = resp.message || 'Unable to start the subscription payment right now.';
					if (resp.debug) {
						errorMessage += ' Debug: ' + resp.debug;
					}
					console.error('Subscription payment start failed:', resp);
					showSubscriptionContractMessage(errorMessage);
					return;
				}

					launchSubscriptionPayment(resp);
				},
			error: function(xhr, status, error) {
				hideLoader();
				$submit.prop('disabled', false).text(originalText);
				console.error('Subscription payment AJAX error:', status, error, xhr && xhr.responseText);
				var responseText = xhr && xhr.responseText ? xhr.responseText : '';
				var message = 'Unable to start the subscription payment right now.';
				if (responseText) {
					message += ' Debug: ' + responseText.substring(0, 300);
				}
				showSubscriptionContractMessage(message);
			}
			});
		});

		$(document).on('submit', '#subscription-payment-form', function(e) {
			e.preventDefault();

			if (!subscriptionStripe || !subscriptionElements) {
				showSubscriptionMessage('We could not load the secure payment form. Please refresh and try again.');
				return;
			}

			var $submit = $('#subscription-pay');
			var originalText = $submit.text();

			resetSubscriptionMessage();
			$submit.prop('disabled', true).addClass('is-loading').text('Please wait…');

			var confirmMethod = $(this).attr('data-intent-type') === 'setup' ? 'confirmSetup' : 'confirmPayment';
			subscriptionStripe[confirmMethod]({
				elements: subscriptionElements,
				redirect: 'if_required'
			}).then(function(result) {
				if (result.error) {
					$submit.prop('disabled', false).removeClass('is-loading').text(originalText);
					showSubscriptionMessage(result.error.message || 'Your payment could not be completed. Please try again.');
					return;
				}

				subscriptionCompleted = true;
				completeSubscriptionPayment();
			}).catch(function(error) {
				$submit.prop('disabled', false).removeClass('is-loading').text(originalText);
				console.error('Subscription payment confirmation failed:', error);
				showSubscriptionMessage('Your payment could not be completed. Please try again.');
			});
		});

	$('.open-sub').on('click', function() {

		console.log('--- OPEN SUB CLICKED ---');

		var id   = $(this).attr('data-id');
		var term = $(this).attr('data-term') || '28'; // 28, 6, or 12

		console.log('Button data → id:', id, 'term:', term);

		// Determine contract type based on term
		var type = (term == 6) ? '6_month' : (term == 12 ? '12_month' : 'general');
		console.log('Resolved contract type:', type);

		// Set form action
		var actionUrl = '/buy-credits/subscribe/' + id + '/?term=' + term;
		console.log('Setting form action:', actionUrl);
		resetSubscriptionModalState();
		$('.modal__subscribe .sub-form').attr('action', actionUrl);

		// Clear old content while loading
		console.log('Clearing old contract content...');
		$('#sub_terms').html('<p class="loading">Loading terms...</p>');

		// Fetch contract content
		console.log('Starting AJAX request for contract terms...');
		showLoader();

		$.ajax({
			url: '/buy-credits/get-contract/',
			type: 'GET',
			data: { type: type },
			dataType: 'json',

			beforeSend: function() {
				console.log('AJAX beforeSend fired');
			},

			success: function(resp) {
				console.log('AJAX SUCCESS:', resp);
				hideLoader();

				if (resp.status === 'success') {
					console.log('Contract HTML received, injecting into #sub_terms');
					$('#sub_terms').html(resp.html);
				} else {
					console.warn('Contract request returned non-success status:', resp.status);
					$('#sub_terms').html('<p class="text-red">Unable to load contract terms.</p>');
				}
			},

			error: function(xhr, status, error) {
				hideLoader();
				console.error('AJAX ERROR');
				console.error('Status:', status);
				console.error('Error:', error);
				console.error('XHR response:', xhr.responseText);

				$('#sub_terms').html('<p class="text-red">Error loading contract terms.</p>');
			},

			complete: function() {
				console.log('AJAX request finished (complete callback)');
			}
		});

		console.log('Opening subscribe modal UI...');
		$('body').addClass('menu-open');
		$('.modal__subscribe').addClass('open');

		console.log('--- END open-sub click handler ---');
	});

	$('.cancel-sub').on('click', function() {
		closeSubscriptionModal();
	});

	$('.modal__subscribe').on('click', function(event) {
		if (event.target === this) {
			closeSubscriptionModal();
		}
	});


	function reopenKlarnaModal(status, clientSecret) {
		$('body').addClass('menu-open');
		$('.modal__credits-payment').addClass('open');
		$('.step').hide();
		$('#error-message').text('');
		if (status !== 'succeeded') {
			$('#step-payment').show();
			$('#payment-form').attr('data-client-secret', clientSecret);
			initialiseStripeForm();
			$('#error-message').text('Your payment was not completed. Please try again.');
			return;
		}

		// Verify and settle the return on the server before showing confirmation.
		showLoader();
		$.post('/buy-credits/confirm-klarna/', { payment_intent: window.payg_redirect_pi }, function(res) {
			if (res.credits !== undefined) $('#credits_amount').text(res.credits);
			if (res.amount !== undefined) $('#credits_price').text(parseFloat(res.amount).toFixed(2));
			window.payg_credit_id = res.credit_id;
			if (res.status === 'complete' || res.status === 'password_required') {
				$(res.status === 'complete' ? '#step-complete' : '#step-password').show();
				const cleanUrl = new URL(window.location.href);
				['payment_intent', 'payment_intent_client_secret', 'redirect_status'].forEach(key => cleanUrl.searchParams.delete(key));
				window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
				return;
			}
			$('#step-payment').show();
			$('#payment-form').show().children().not('#error-message').hide();
			$('#error-message').text(res.message || 'Unable to confirm your payment. Please check your credits shortly.');
		}, 'json').fail(function() {
			$('#step-payment').show();
			$('#payment-form').show().children().not('#error-message').hide();
			$('#error-message').text('Unable to confirm your payment. Please check your credits shortly.');
		}).always(hideLoader);
	}

	// Detect Klarna return
	const urlParams = new URLSearchParams(window.location.search);
	const pi = urlParams.get("payment_intent");
	window.payg_redirect_pi = pi;
	const status = urlParams.get("redirect_status");
	const clientSecret = urlParams.get("payment_intent_client_secret");

	if (pi && status && clientSecret) {
		console.log("Klarna redirect detected:", status);

		// Open modal + resume payment flow
		reopenKlarnaModal(status, clientSecret);

		// Clean URL (remove Stripe query params)
		//window.history.replaceState({}, document.title, "/buy-credits/");
	}
});



function showLoader() {
	$('#global-loader').addClass('show');
}

function hideLoader() {
	$('#global-loader').removeClass('show');
}
